
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Blogger Program',
    howItWorks: 'How it works',

    // Step 1
    step1Title: 'Create a quality review',
    step1Description: 'Record a video with a full review of SHOT bot. We recommend showing:',
    step1Item1: 'All bot features',
    step1Item2: 'Case openings',
    step1Item3: 'Main features',

    // Step 2
    step2Title: 'Post on Instagram or TikTok',
    step2Description:
      'Post the video on your Instagram or TikTok account. Make sure to add hashtags: #cs_shot_bot #cs2. More views — more rewards!',

    // Step 3
    step3Title: 'Contact us',
    step3Description: 'Send a link to your video in private messages to',
    step3Channel: 'SHOT Friends',

    // Step 4
    step4Title: 'Get rewarded',
    step4DescriptionPrefix: 'After video verification you will receive',
    step4DescriptionMiddle: 'for',
    step4DescriptionViews: '100,000 views',
    step4DescriptionSuffix: 'Payouts from 10,000 views once a week. We will create a tracking table.',

    // Warning section
    warningTitle: 'Important rules',
    warningCheck: '⚠️ Fraud check:',
    warningCheckText:
      'We carefully verify all views for authenticity. We use special tools to detect fake views.',
    warningBan: '🚫 Ban:',
    warningBanText: 'Accounts caught using fake views will be permanently banned without any payouts.',
    warningHonest: '✅ Honesty:',
    warningHonestText: 'Play fair — get consistent rewards for quality content!',

    // Contact section
    contactTitle: 'How to participate',
    contactDescription:
      'To participate in the program, message SHOT Friends channel. Send a link to your social media and specify the number of subscribers and average views on your videos.',
    contactButton: 'Message SHOT Friends',
  },
  ru: {
    title: 'Программа для блогеров',
    howItWorks: 'Как это работает',

    // Step 1
    step1Title: 'Создай качественный обзор',
    step1Description: 'Сними видео с полным обзором бота SHOT. Рекомендуем показать:',
    step1Item1: 'Весь функционал бота',
    step1Item2: 'Прокрутку кейсов',
    step1Item3: 'Основные возможности',

    // Step 2
    step2Title: 'Опубликуй в Instagram или TikTok',
    step2Description:
      'Размести видео на своём аккаунте в Instagram или TikTok. Обязательно поставь хэштеги: #cs_shot_bot #cs2. Чем больше просмотров — тем больше вознаграждение!',

    // Step 3
    step3Title: 'Напиши нам',
    step3Description: 'Отправь ссылку на своё видео в личные сообщения канала',
    step3Channel: 'SHOT Friends',

    // Step 4
    step4Title: 'Получай награду',
    step4DescriptionPrefix: 'После проверки видео получишь',
    step4DescriptionMiddle: 'за',
    step4DescriptionViews: '100 000 просмотров',
    step4DescriptionSuffix: 'Выплаты от 10 000 просмотров 1 раз в неделю. Сделаем таблицу для учета.',

    // Warning section
    warningTitle: 'Важные правила',
    warningCheck: '⚠️ Проверка на накрутку:',
    warningCheckText:
      'Мы тщательно проверяем все просмотры на подлинность. Используем специальные инструменты для выявления накрутки.',
    warningBan: '🚫 Блокировка:',
    warningBanText:
      'Аккаунты, замеченные в накрутке просмотров, будут заблокированы навсегда без каких-либо выплат.',
    warningHonest: '✅ Честность:',
    warningHonestText: 'Делай все честно — получай стабильные вознаграждения за качественный контент!',

    // Contact section
    contactTitle: 'Как принять участие',
    contactDescription:
      'Чтобы принять участие в программе, напиши в личные сообщения канала SHOT Friends. Отправь ссылку на свои соц сети и укажи количество подписчиков и сколько в среднем набирают просмотров твои видео.',
    contactButton: 'Написать в SHOT Friends',
  },
  uz: {
    title: 'Blogerlar dasturi',
    howItWorks: 'Bu qanday ishlaydi',

    // Step 1
    step1Title: 'Sifatli sharh yarating',
    step1Description: 'SHOT boti haqida toʻliq sharh videosini yozing. Koʻrsatishni tavsiya qilamiz:',
    step1Item1: 'Botning barcha funksiyalari',
    step1Item2: 'Keys ochish',
    step1Item3: 'Asosiy imkoniyatlar',

    // Step 2
    step2Title: 'Instagram yoki TikTokda joylashtiring',
    step2Description:
      'Videoni Instagram yoki TikTok akkauntingizda joylashtiring. Xeshteglarni qoʻshishni unutmang: #cs_shot_bot #cs2. Koʻrishlar qancha koʻp boʻlsa, mukofot ham shuncha koʻp!',

    // Step 3
    step3Title: 'Bizga yozing',
    step3Description: 'Videongizga havolani shaxsiy xabarlarda yuboring:',
    step3Channel: 'SHOT Friends',

    // Step 4
    step4Title: 'Mukofot oling',
    step4DescriptionPrefix: 'Video tekshirilgandan soʻng',
    step4DescriptionMiddle: 'uchun',
    step4DescriptionViews: '100 000 koʻrish',
    step4DescriptionSuffix: 'olasiz! Haftada bir marta 10 000 koʻrishdan toʻlovlar. Hisobni yuritish uchun jadval yaratamiz.',

    // Warning section
    warningTitle: 'Muhim qoidalar',
    warningCheck: '⚠️ Firibgarlikni tekshirish:',
    warningCheckText:
      'Biz barcha koʻrishlarni haqiqiyligi uchun sinchkovlik bilan tekshiramiz. Soxta koʻrishlarni aniqlash uchun maxsus vositalardan foydalanamiz.',
    warningBan: '🚫 Bloklash:',
    warningBanText:
      'Soxta koʻrishlar foydalangan akkauntlar hech qanday toʻlovsiz abadiy bloklanadi.',
    warningHonest: '✅ Halollik:',
    warningHonestText: 'Halol oʻynang — sifatli kontent uchun barqaror mukofotlar oling!',

    // Contact section
    contactTitle: 'Qanday ishtirok etish mumkin',
    contactDescription:
      'Dasturda ishtirok etish uchun SHOT Friends kanaliga xabar yozing. Ijtimoiy tarmoqlaringizga havola yuboring va obunachilar soni hamda videolaringiz oʻrtacha qancha koʻrish toʻplayotganini koʻrsating.',
    contactButton: 'SHOT Friendsga yozish',
  },
});
